import React from "react";
import { formatNotionalValue } from "./notionalCellRendererHelper";

const NotionalCellRenderer = (params: any) => {
  const formattedValue = formatNotionalValue(
    params.value,
    params.data?.instrumentType,
  );

  return (
    <div
      data-testid="NotionalCellContainer"
      id="NotionalCellContainer"
    >
      {formattedValue}
    </div>
  );
};

export default NotionalCellRenderer;
